import {gql} from "@apollo/client";

export const getCardIsEnabledQuery = gql`
    query GetCustomer($customerId: String!) {
        customer: customer_Admin(id: $customerId) {
            id
            profile {
                config {
                    cardsEnabled
                }
            }
        }
    }
`

export const getCardsV2Query = gql`
  query GetCardsV2_Admin($customerId: String!) {
    getCardV2_Admin(customerId: $customerId) {
      id
      physicalCardStatus
      last4Digit
      cardType
      cardToken
      externalCardId
    }
  }
`

// deleteCardV2Mutation lives in ./mutations.js